<template>
  <el-main>
    <el-row>
      <h2>项目成绩汇总</h2>
    </el-row>      

          

      <b-row>
        <b-col lg="4" class="my-1"> 
                <b-input-group size="sm">
                      <b-form-select v-model="selSchool" :options="schoolList"
                      @change="myChange"
                      ></b-form-select>
                      <b-input-group-append>
                      <b-button @click="getSchooScore">显示成绩</b-button>
                      </b-input-group-append>
                    
                   
                      
                </b-input-group>      
                
                  
        </b-col>

        <b-col lg="4" class="my-1" v-show="isshow">  
             <b-input-group size="sm">
                     <b-form-select v-model="filter" :options="classList"
                     
                      ></b-form-select>  
               </b-input-group>                          
        </b-col>

        <b-col lg="4" class="my-1" v-show="isshow"> 
             <b-input-group size="sm">
               
                  <b-form-input
                    v-model="filter"
                    type="search"
                    id="filterInput"
                    placeholder="输入查找的内容..."
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button :disabled="!filter" @click="filter = ''">清空</b-button>
                  </b-input-group-append>
            </b-input-group>
                       
        </b-col>
        
      </b-row>
      <b-row v-show="isshow">
        
     </b-row>       



  
      
       

 <b-col lg="18" class="h-100"  v-show="isshow">
       符合条件记录数:{{totalRows}}
       <b-table
       
               
        hover 
        :items="items" 
        :fields="fields"
        :small="true"
        :bordered="true"
        :head-variant="headVariant"
        :per-page="perPage"
        :current-page="currentPage"
        :filter="filter"
        :filter-included-fields="filterOn"
         @filtered="onFiltered"
         class="table"
        >
            <!-- A virtual column -->
            <template v-slot:cell(index)="data">
              {{ (currentPage-1)*perPage+data.index + 1 }}
            </template>

             <template v-slot:cell(actions)="row">
                <b-button size="sm" @click="info(row.item, row.index, $event.target)" class="mr-2">
                  查看详情
                </b-button>
                
              </template>

        </b-table>


         
         <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
         
        ></b-pagination>

    </b-col>     


  </el-main>
  

</template>
<script>
import axios from 'axios'
import qs from 'qs'

export default {
  data() {
    return {
      		img_src:'',
          fit:'contain',
          xmList: [],
          currentRow: null,
        
          title:'hello world',
          schoolList:[],
          classList:[],
          selXmName:'',
          selSchool:null,
          selClass:null,
          editableTabs: [
            {
                title: 'Tab 1',
                name: '1',
                content: 'Tab 1 content'
            }, 
            {
                  title: 'Tab 2',
                  name: '2',
                  content: 'Tab 2 content'
            }
            ],
            sel_xm:'',
            items: [
                 
             ],
             fields: [
              
             ],
              headVariant:'light',
              totalRows: 0,
              currentPage: 1,
              perPage: 30,
              filter: null,
              filterOn: ['kh','nm','cl'],
              isshow:false,

         };
  },

   activated() {
            if (this.$route.params.xm!=null)
            {
                  this.filter=null;
                  this.selXmName=this.$route.params.xm;
                  this.sel_xm=this.selXmName;                


                  console.log(this.selXmName);
                  this.iniSchool();
            }
  },

  methods: {
     
       getSchoolList () {
    
          axios.post('/cjman?op=exameScoreSchool',qs.stringify({"xm":this.selXmName})).then((res)=>{
                  console.log(res)
                  this.schoolList=res.data.sc;

                  let nuv={ value: null, text: '请选择学校' };
                  this.schoolList.unshift(nuv);
                  
              }).catch((res)=>{
                  console.log(response)
              })
        },

     
    
        iniSchool() {
       
       
           this.getSchoolList();
          
  
        },

          myChange(value)
          {
            console.log(value);
            this.isshow=false;

          },

         getSchooScore () {
      
          axios.post('/cjman?op=exameSchoolZf',qs.stringify({"xm":this.selXmName,'school':this.selSchool})).then((res)=>{
                  console.log(res)
                  this.filter=null;
                  this.fields=res.data.kemu;
                  this.items=res.data.score;
                  this.totalRows = this.items.length;

                  this.classList=res.data.class;
                  let nuv={ value: null, text: '请选择班级' };
                  this.classList.unshift(nuv);

                  if (this.classList.length>=1)
                  {
                    this.isshow=true;
                  }
                  console.log(res.data.class);
                  
              }).catch((res)=>{
                  console.log(response)
              })
        },
        onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
        },

        info(item, index, button) {
          console.log(item.kh)
          let xm=this.sel_xm;
          let kh=item.kh;
          let name=item.nm;

          //跳转项目成绩主页
                this.$router.push({

                    name:'qscore',

                    params: { xm:this.sel_xm,kaohao:kh,name:name }

              });

        
      },

     
    
       

  },
}
</script>